import { render, staticRenderFns } from "./SolicitacaoShow.vue?vue&type=template&id=65f0b5d3"
import script from "./SolicitacaoShow.vue?vue&type=script&lang=js"
export * from "./SolicitacaoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports